import { TwinInstruction } from 'api/model'
import { atom } from 'recoil'

const instructionsAtom = atom<TwinInstruction[]>({
  key: 'instructions',
  default: [],
})

const questionTypeInstructionsAtom = atom<TwinInstruction[]>({
  key: 'questionTypeInstructions',
  default: [],
})

export { instructionsAtom, questionTypeInstructionsAtom }
